import React, { useState, useEffect, useRef } from "react";
import emailjs from "@emailjs/browser";
import Select from "react-select";
import Footer2 from "components/Footers/Footer2";
import AdminNavbar from "components/Navbars/AdminNavbar";
import axios from "axios";
import toast from "react-hot-toast";
import ReCAPTCHA from "react-google-recaptcha";


export default function CareerForm() {
  const form = useRef(null);
  const [formStatus, setFormStatus] = useState("idle");
const [captchaToken, setCaptchaToken] = useState(null);
  // const sendEmail = (e) => {
  //   e.preventDefault();
  //   emailjs
  //     .sendForm("service_wcgta79", "template_fafq1l3", form.current, {
  //       publicKey: "fnc0ujCNZPYr2bPnl",
  //     })
  //     .then(
  //       () => {
  //         console.log("SUCCESS!");
  //         setFormStatus("success");
  //         // Check if form.current exists before resetting
  //         if (form.current) {
  //           form.current.reset();
  //         }
  //         setTimeout(() => {
  //           setFormStatus("idle");
  //         }, 3000);
  //       },
  //       (error) => {
  //         console.log("FAILED...", error.text);
  //         setFormStatus("error");
  //         setTimeout(() => {
  //           setFormStatus("idle");
  //         }, 1000);
  //       }
  //     );
  // };

  const sendEmail = async (event) => {
    event.preventDefault();

    const formData = new FormData(event.target);
    formData.append("resume", event.target.resume.files[0]); // Append file manually

    const data = {
      name: formData.get("name")?.trim(),
      email: formData.get("email")?.trim(),
      phone: formData.get("phone")?.trim(),
      date: formData.get("date"),
      qualification: formData.get("qualification")?.trim(),
      board: formData.get("board"),
      state: formData.get("state"),
      branch: formData.get("branch"),
      posttype: formData.get("posttype"),
      experience: formData.get("experience"),
      address: formData.get("address")?.trim(),
      gender: formData.get("gender"),
      resume: formData.get("resume"),
      captcha: captchaToken,
    };

    // Validation checks
    if (!data.name || data.name.length < 3) {
      toast.error("Name must be at least 3 characters long");
      return;
    }
    if (!data.email) {
      toast.error("Email is required");
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) {
      toast.error("Enter a valid email address");
      return;
    }
    if (!data.phone) {
      toast.error("Phone number is required");
      return;
    }
    if (!/^\d{10}$/.test(data.phone)) {
      toast.error("Enter a valid 10-digit phone number");
      return;
    }
    if (!data.date) {
      toast.error("Date of Birth is required");
      return;
    }
    if (!data.qualification || data.qualification.length < 2) {
      toast.error("Qualification must be at least 2 characters long");
      return;
    }
    if (!data.board) {
      toast.error("Please select a Board");
      return;
    }
    if (!data.state) {
      toast.error("Please select a State");
      return;
    }
    if (!data.branch) {
      toast.error("Please select a Branch");
      return;
    }
    if (!data.posttype) {
      toast.error("Please select a Post Type");
      return;
    }
    if (!data.experience) {
      toast.error("Please select your Experience");
      return;
    }
    if (!data.address || data.address.length < 3) {
      toast.error("Address must be at least 3 characters long");
      return;
    }
    if (!data.gender) {
      toast.error("Please select a Gender");
      return;
    }
    if (!data.resume) {
      toast.error("Resume file is required");
      return;
    }
    const allowedFileTypes = ["application/pdf", "application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"];
    if (!allowedFileTypes.includes(data.resume.type)) {
      toast.error("Only PDF, DOC, or DOCX files are allowed");
      return;
    }
     if (!captchaToken) {
      toast.error("Please verify you're not a robot");
      return;
    }

    try {
      const response = await axios.post("https://api.juniortoes.com/api/careers", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.status === 200) {
        toast.success("Form submitted successfully!");
        setFormStatus("success");
      }
    } catch (error) {
      console.error("Form submission error:", error);
      toast.error("Something went wrong. Please try again.");
      setFormStatus("error");
    }
  };


  const options1 = [
    { value: "cbse", label: "CBSE" },
    { value: "icse", label: "ICSE" },
    { value: "icse_cbse", label: "ICSE/CBSE" },
    { value: "igcse", label: "IGCSE" },
    { value: "state", label: "STATE" },
  ];

  const options2 = [
    { value: "andhra-pradesh", label: "Andhra Pradesh" },
    { value: "arunachal-pradesh", label: "Arunachal Pradesh" },
    { value: "assam", label: "Assam" },
    { value: "bihar", label: "Bihar" },
    { value: "chhattisgarh", label: "Chhattisgarh" },
    { value: "goa", label: "Goa" },
    { value: "gujarat", label: "Gujarat" },
    { value: "haryana", label: "Haryana" },
    { value: "himachal-pradesh", label: "Himachal Pradesh" },
    { value: "jharkhand", label: "Jharkhand" },
    { value: "karnataka", label: "Karnataka" },
    { value: "kerala", label: "Kerala" },
    { value: "madhya-pradesh", label: "Madhya Pradesh" },
    { value: "maharashtra", label: "Maharashtra" },
    { value: "manipur", label: "Manipur" },
    { value: "meghalaya", label: "Meghalaya" },
    { value: "mizoram", label: "Mizoram" },
    { value: "nagaland", label: "Nagaland" },
    { value: "odisha", label: "Odisha" },
    { value: "punjab", label: "Punjab" },
    { value: "rajasthan", label: "Rajasthan" },
    { value: "sikkim", label: "Sikkim" },
    { value: "tamil-nadu", label: "Tamil Nadu" },
    { value: "telangana", label: "Telangana" },
    { value: "tripura", label: "Tripura" },
    { value: "uttar-pradesh", label: "Uttar Pradesh" },
    { value: "uttarakhand", label: "Uttarakhand" },
    { value: "west-bengal", label: "West Bengal" },
    { value: "andaman-nicobar", label: "Andaman and Nicobar Islands" },
    { value: "chandigarh", label: "Chandigarh" },
    { value: "delhi", label: "Delhi" },
    { value: "lakshadweep", label: "Lakshadweep" },
    { value: "puducherry", label: "Puducherry" },
    { value: "ladakh", label: "Ladakh" },
    { value: "jammu-kashmir", label: "Jammu and Kashmir" },
  ];

  const options3 = [
    { value: "Malleshwaram", label: "Malleshwaram" },
    { value: "RR Nagar", label: "RR Nagar" },
    { value: "Hesaraghatta Road", label: "Hesaraghatta Road" },
    { value: "RMV - Dollar Colony ", label: "RMV - Dollar Colony " },
    { value: "Rajajinagar", label: "Rajajinagar" },
    // { value: "Yelahanka", label: "Yelahanka" },
    { value: "Acharya College Campus", label: "Acharya College Campus" },
    { value: "Vijayanagar", label: "Vijayanagar" },
    { value: "HSR Layout", label: "HSR Layout" },
    { value: "Shubh Enclave - Haralur, Sarjapur", label: "Shubh Enclave - Haralur, Sarjapur" },
    { value: "Indiranagar", label: "Indiranagar" },
    { value: "Jayalakshmipuram - Mysore", label: "Jayalakshmipuram - Mysore" },
    { value: "JP Nagar Metro Station", label: "JP Nagar Metro Station" },
    { value: "Vidyaranyapura", label: "Vidyaranyapura" },
    { value: "Mandya", label: "Mandya" },
    { value: "Whitefield", label: "Whitefield" },
    { value: "Nelamangala", label: "Nelamangala" },
    { value: "Nagarbhavi", label: "Nagarbhavi" },
    { value: "Rukmini Nagar HMT Layout", label: "Rukmini Nagar HMT Layout" },
    { value: "Jindal City Nagasandra", label: "Jindal City Nagasandra" },
    { value: "Poornapragna Layout", label: "Poornapragna Layout" },
    { value: "Hebbal Dasarahalli", label: "Hebbal Dasarahalli" },
    { value: "Bharath Nagar", label: "Bharath Nagar" },
    { value: "Banashankari 3rd Stage", label: "Banashankari 3rd Stage" },
    { value: "Tumkur Adarshanagar", label: "Tumkur Adarshanagar" },
    { value: "Sahakarnagar", label: "Sahakarnagar" },
  ];

  const options5 = [
    { value: "Head of School", label: "Head of School" },
    { value: "teaching", label: "Teaching" },
    { value: "Admission Manager", label: "Admission Manager" },
    { value: "Operational Manager", label: "Operational Manager" },
  ];

  const options7 = [
    { value: "fresher", label: "Fresher" },
    { value: "1yr", label: "1yr" },
    { value: "2yrs", label: "2yrs" },
    { value: "3yrs", label: "3Yrs" },
    { value: "4yrs", label: "4Yrs" },
    { value: "5yrs", label: "5Yrs" },
    { value: "6yrs", label: "6Yrs" },
    { value: "7yrs", label: "7Yrs" },
    { value: "8yrs", label: "8Yrs" },
    { value: "9yrs", label: "9Yrs" },
    { value: "10yrs", label: "9Yrs" },
    { value: "more", label: "More" },
  ];

  const [options, setOptions] = useState(options7);
  const [selectedOption, setSelectedOption] = useState(null);
  const [isManualInput, setIsManualInput] = useState(false);
  const [manualInput, setManualInput] = useState("");

  const handleChange = (option) => {
    if (option.value === "more") {
      // Enable manual input when "More" is selected
      setIsManualInput(true);
      setSelectedOption(null);
    } else {
      // Select the predefined option
      setSelectedOption(option);
      setIsManualInput(false);
      setManualInput("");
    }
  };

  const handleManualInputChange = (e) => {
    setManualInput(e.target.value);
    setSelectedOption({ value: e.target.value, label: e.target.value });
  };
  return (
    <>
      {/* <AdminNavbar fixed /> */}
      <section className="xl:block lg:block md:block sm:block block">
        <div
          className="bg-gray-100 xl:mb-12 mb-12 rounded-lg xl:p-8 xl:w-7/12 lg:w-10/12 md:w-10/12 w-10/12  justify-center mx-auto xl:px-0 px-4 lg:p-8 p-6"
          style={{ border: "1px solid #e8e8e8" }}
        >
          {formStatus === "success" && (
            <div className="text-center text-green-500 sofia-pro">
              Thank you for submitting the form!
            </div>
          )}

          {/* Show Error Message */}
          {formStatus === "error" && (
            <div className="text-center text-red-500 sofia-pro">
              There was an error submitting the form. Please try again.
            </div>
          )}
          <h1 className="xl:text-4xl lg:text-3xl text-2xl  text-black  font-bold  text-center ">
            Application Form
          </h1>

          <p className="text-lg pt-2 pt-2 text-blue text-center font-bold">
            Please fill in all the required fields (marked with *)
          </p>

          {formStatus === "idle" && (
            <form
              className="xl:mt-8 lg:mt-8 md:mt-8 mt-4"
              ref={form}
              onSubmit={sendEmail}
            >
              <div className="xl:mt-12 lg:mt-12 md:mt-12 mt-6 flex flex-wrap  ">
                {/* Board Selection */}
                <div className="xl:w-6/12 lg:w-6/12 md:w-6/12 w-full">

                  <div>
                    <label
                      className="text-black xl:text-lg lg:text-lg text-base"
                      htmlFor="academic"
                    >
                      Please Select Board
                      <span className="required text-red-500"> *</span>
                    </label>
                    <Select
                      className="w-full text-base rounded"
                      classNamePrefix="custom-select"
                      options={options1}
                      placeholder="Please Select Board"
                      isSearchable={true}
                      id="academic"
                      name="board"
                      required
                    />
                  </div>
                </div>

                {/* State Selection */}
                <div className="xl:w-6/12 lg:w-6/12 md:w-6/12 w-full px-1 xl:mt-0 lg:mt-0 md:mt-0 mt-6">
                  <div>
                    <label
                      className="text-black xl:text-lg lg:text-lg text-base"
                      htmlFor="state"
                    >
                      Select State
                      <span className="required text-red-500"> *</span>
                    </label>
                    <Select
                      className="w-full text-base rounded"
                      classNamePrefix="custom-select"
                      options={options2}
                      placeholder="Select State"
                      isSearchable={true}
                      id="state"
                      name="state"
                      required
                    />
                  </div>
                </div>
              </div>

              <div className="mt-6 flex flex-wrap">
                <div className="xl:w-6/12 lg:w-6/12 md:w-6/12 w-full">
                  <label
                    className="text-black xl:text-lg lg:text-lg text-base"
                    htmlFor="state"
                  >
                    Select Branch
                    <span className="required text-red-500"> *</span>
                  </label>

                  <Select
                    className="xl:w-full w-full"
                    classNamePrefix="custom-select"
                    options={options3}
                    placeholder="Select Branch"
                    isSearchable={true} // Enable search functionality
                    id="branch"
                    name="branch"
                    required
                  />
                </div>

                <div className="xl:w-6/12 lg:w-6/12 md:w-6/12 w-full px-1 xl:mt-0 lg:mt-0 md:mt-0 mt-6">
                  <label
                    className="text-black xl:text-lg lg:text-lg text-base"
                    htmlFor="state"
                  >
                    Post Type
                    <span className="required text-red-500"> *</span>
                  </label>

                  <Select
                    className="xl:w-full w-full"
                    classNamePrefix="custom-select"
                    options={options5}
                    placeholder="Post Type"
                    isSearchable={true} // Enable search functionality
                    id="post"
                    name="posttype"
                    required
                  />
                </div>
              </div>

              <div className="mt-6 flex flex-wrap">
                <div className="xl:w-6/12 lg:w-6/12 md:w-6/12 w-full">
                  <div>
                    <label
                      class="text-black xl:text-lg lg:text-lg text-base"
                      for="academic"
                    >
                      Name
                      <span class="required text-red-500"> *</span>
                    </label>
                  </div>
                  <input
                    className="xl:w-full w-full rounded borderform"
                    type="text"
                    id="text"
                    name="name"
                    placeholder="Name "
                    required
                  />
                </div>

                <div className="xl:w-6/12 lg:w-6/12 md:w-6/12 w-full px-1 xl:mt-0 lg:mt-0 md:mt-0 mt-6">
                  <div>
                    <label
                      class="text-black xl:text-base lg:text-base text-base"
                      for="academic"
                    >
                      Date Of Birth
                      <span class="required text-red-500"> *</span>
                    </label>
                  </div>
                  <input
                    className="w-full rounded borderform py-extra"
                    type="date"
                    id="dob"
                    name="date"
                    placeholder="Date of Birth"
                    required
                  />
                </div>
              </div>

              <div className="mt-6 flex flex-wrap">
                <div className="xl:w-6/12 lg:w-6/12 md:w-6/12 w-full">
                  <div>
                    <label
                      class="text-blackxl:text-lg lg:text-lg text-base"
                      for="academic"
                    >
                      Qualification
                      <span class="required text-red-500"> *</span>
                    </label>
                  </div>
                  <input
                    className="w-full rounded borderform  py-extra"
                    type="text"
                    id="text"
                    name="qualification"
                    placeholder="Qualification "
                    required
                  />
                </div>

                <div className="xl:w-6/12 lg:w-6/12 md:w-6/12 w-full px-1 xl:mt-0 lg:mt-0 md:mt-0 mt-6">
                  <label
                    className="text-black xl:text-lg lg:text-lg text-base"
                    htmlFor="experience"
                  >
                    Select Experience
                    <span className="required text-red-500"> *</span>
                  </label>

                  {isManualInput ? (
                    <input
                      type="text"
                      className="xl:w-full w-full borderform rounded px-3  py-extra"
                      placeholder="Add experience "
                      value={manualInput}
                      onChange={handleManualInputChange}
                      onBlur={() => {
                        if (!manualInput) {
                          setIsManualInput(false); // Revert back to dropdown if input is empty
                        }
                      }}
                    />
                  ) : (
                    <Select
                      className="xl:w-full w-full "
                      classNamePrefix="custom-select"
                      options={options}
                      placeholder="Select Experience"
                      isSearchable={true}
                      id="experience"
                      name="experience"
                      value={selectedOption}
                      onChange={handleChange}
                      required
                    />
                  )}
                </div>
              </div>

              <div className="mt-6 flex flex-wrap">
                <div className="xl:w-6/12 lg:w-6/12 md:w-6/12 w-full">
                  <div>
                    <label
                      class="text-black xl:text-lg lg:text-lg text-base"
                      for="academic"
                    >
                      Email Id
                      <span class="required text-red-500"> *</span>
                    </label>
                  </div>
                  <input
                    className="w-full rounded borderform"
                    type="text"
                    id="text"
                    name="email"
                    placeholder="Email"
                    required
                  />
                </div>

                <div className="xl:w-6/12 lg:w-6/12 md:w-6/12 w-full px-1 xl:mt-0 lg:mt-0 md:mt-0 mt-6">
                  <div>
                    <label
                      class="text-black xl:text-lg lg:text-lg text-base"
                      for="academic"
                    >
                      Phone Number
                      <span class="required text-red-500"> *</span>
                    </label>
                  </div>
                  <input
                    className="w-full rounded borderform"
                    type="number"
                    id="number"
                    name="phone"
                    placeholder="Phone Number"
                    required
                  />
                </div>
              </div>

              <div className="mt-6 flex flex-wrap">
                <div className="xl:w-6/12 lg:w-6/12 md:w-6/12 w-full">
                  <div>
                    <label class="text-black text-lg" for="address">
                      Address
                      <span class="required text-red-500"> *</span>
                    </label>
                  </div>
                  <input
                    className="w-full rounded borderform border-2"
                    type="text"
                    id="address"
                    name="address"
                    placeholder="Enter your address"
                    pattern="[A-Za-z0-9\s,.-]+"
                    title=" Address"
                    required
                  />
                </div>

                <div className="xl:w-6/12 lg:w-6/12 md:w-6/12 w-full px-1 ">
                  <div className="flex items-center xl:pt-4 pt-4 mt-6 gap-4 xl:mt-6">
                    <div>
                      <label className="text-black text-lg" htmlFor="gender">
                        Gender
                        <span className="required text-red-500"> *</span>
                      </label>
                    </div>

                    <div className="flex items-center gap-2">
                      <input
                        type="radio"
                        id="male"
                        name="gender"
                        value="male"
                        required
                        className="mr-2"
                      />
                      <label htmlFor="male" className="mr-4">
                        Male
                      </label>

                      <input
                        type="radio"
                        id="female"
                        name="gender"
                        value="female"
                        className="mr-2"
                      />
                      <label htmlFor="female">Female</label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mt-6">
                <label
                  class="text-black xl:text-lg lg:text-lg text-base "
                  for="resume"
                >
                  Upload Resume
                  <span class="required text-red-500"> *</span>
                </label>
              </div>
              <input
                class="xl:w-full xl:py-2 py-2 mb-4 w-full bg-white rounded borderform "
                type="file"
                id="resume"
                name="resume"
                accept=".pdf, .doc, .docx"
                required
              />

              <ReCAPTCHA
                sitekey="6Lff5xMsAAAAAI23wsM17cv64hBjF2Q7ZSlCYBee"
                onChange={(token) => setCaptchaToken(token)}
                className="w-12/12"
              />

              <div className="flex justify-center xl:mt-6 mt-6">
                <button
                  className="xl:mt-8 px-8 xl:px-8 mt-8 xl:py-2 py-2 border-0 focus:outline-none text-white text-center rounded"
                  style={{ background: "#2d86a4" }}
                  type="submit"
                >
                  Submit
                </button>
              </div>
            </form>
          )}
        </div>
      </section>

      {/* mobile view */}
      <section className="xl:hidden lg:hidden md:hidden sm:hidden hidden px-4">
        <div
          className="bg-gray-100  mb-12 rounded-lg  justify-center mx-auto   p-6"
          style={{ border: "1px solid #e8e8e8" }}
        >
          {formStatus === "success" && (
            <div className="text-center text-green-500 sofia-pro">
              Thank you for submitting the form!
            </div>
          )}

          {/* Show Error Message */}
          {formStatus === "error" && (
            <div className="text-center text-red-500 sofia-pro">
              There was an error submitting the form. Please try again.
            </div>
          )}
          <h1 className=" text-2xl  text-black  font-bold  text-center ">
            Application Form
          </h1>
          <p className="text-lg pt-2 text-blue text-center font-bold">
            Please fill in all the required fields (marked with *)
          </p>

          {formStatus === "idle" && (
            <form className=" mt-8" ref={form} onSubmit={sendEmail}>
              <div className="mt-6">
                <label className="text-black  text-base  " htmlFor="academic">
                  Please Select Board
                  <span className="required text-red-500"> *</span>
                </label>

                <Select
                  className="w-12/12 text-base rounded "
                  classNamePrefix="custom-select"
                  options={options1}
                  placeholder="Please Select Board"
                  isSearchable={true}
                  id="academic"
                  name="board"
                  required
                />
              </div>

              <div className="mt-6">
                <label className="text-black text-base" htmlFor="academic">
                  Select State
                  <span className="required text-red-500"> *</span>
                </label>

                <Select
                  className=" w-full"
                  classNamePrefix="custom-select"
                  options={options2}
                  placeholder="Select State"
                  isSearchable={true} // Enables searching in the dropdown
                  id="academic"
                  name="state"
                  required
                />
              </div>

              <div className="mt-6">
                <label className="text-black  text-base" htmlFor="state">
                  Select Branch
                  <span className="required text-red-500"> *</span>
                </label>

                <Select
                  className="xl:w-full w-full"
                  classNamePrefix="custom-select"
                  options={options3}
                  placeholder="Select Branch"
                  isSearchable={true} // Enable search functionality
                  id="state"
                  name="branch"
                  required
                />
              </div>

              <div className="mt-6">
                <label className="text-black text-base" htmlFor="state">
                  Post Type
                  <span className="required text-red-500"> *</span>
                </label>

                <Select
                  className=" w-full"
                  classNamePrefix="custom-select"
                  options={options5}
                  placeholder="Post Type"
                  isSearchable={true} // Enable search functionality
                  id="state"
                  name="posttype"
                  required
                />
              </div>

              <div className="mt-6">
                <div>
                  <label class="text-black text-base" for="academic">
                    Name
                    <span class="required text-red-500"> *</span>
                  </label>
                </div>
                <input
                  className=" w-full rounded borderform"
                  type="text"
                  id="text"
                  placeholder="Name "
                  name="name"
                  required
                />
              </div>

              <div className="mt-6">
                <div>
                  <label class="text-black  text-base" for="academic">
                    Date Of Birth
                    <span class="required text-red-500"> *</span>
                  </label>
                </div>
                <input
                  className="w-full rounded borderform py-2"
                  type="date"
                  id="dob"
                  name="date"
                  placeholder="Date of Birth"
                  required
                />
              </div>

              <div className="mt-6">
                <div>
                  <label class="text-black  text-base" for="academic">
                    Qualification
                    <span class="required text-red-500"> *</span>
                  </label>
                </div>
                <input
                  className="w-full rounded borderform"
                  type="text"
                  id="text"
                  name="qualification"
                  placeholder="Qualification "
                  required
                />
              </div>

              <div className="mt-6">
                <label className="text-black  text-base" htmlFor="experience">
                  Select Experience
                  <span className="required text-red-500"> *</span>
                </label>

                {isManualInput ? (
                  <input
                    type="text"
                    className=" borderform rounded px-3 py-2"

                    placeholder="Add experience "
                    value={manualInput}
                    onChange={handleManualInputChange}
                    onBlur={() => {
                      if (!manualInput) {
                        setIsManualInput(false); // Revert back to dropdown if input is empty
                      }
                    }}
                  />
                ) : (
                  <Select
                    className="xl:w-full w-full"
                    classNamePrefix="custom-select"
                    options={options}
                    placeholder="Select Experience"
                    isSearchable={true}
                    id="experience"
                    name="experience"
                    value={selectedOption}
                    onChange={handleChange}
                    required
                  />
                )}
              </div>

              <div className="mt-6">
                <div>
                  <label class="text-black  text-base" for="academic">
                    Email Id
                    <span class="required text-red-500"> *</span>
                  </label>
                </div>
                <input
                  className="w-full rounded borderform"
                  type="text"
                  id="text"
                  name="email"
                  placeholder="Email"
                  required
                />
              </div>

              <div className="mt-6">
                <div>
                  <label class="text-black  text-base" for="academic">
                    Phone Number
                    <span class="required text-red-500"> *</span>
                  </label>
                </div>
                <input
                  className="w-full rounded borderform"
                  type="number"
                  id="number"
                  name="phone"
                  placeholder="Phone Number"
                  required
                />
              </div>

              <div className="mt-6">
                <div>
                  <label class="text-black text-lg" for="address">
                    Address
                    <span class="required text-red-500"> *</span>
                  </label>
                </div>
                <input
                  className="w-full rounded borderform border-2"
                  type="text"
                  id="address"
                  placeholder="Enter your address"
                  pattern="[A-Za-z0-9\s,.-]+"
                  title=" Address"
                  name="address"
                  required
                />
              </div>

              <div className="mt-6">
                <div className="flex items-center  pt-4 mt-6 gap-4 ">
                  <div>
                    <label className="text-black text-base" htmlFor="gender">
                      Gender
                      <span className="required text-red-500"> *</span>
                    </label>
                  </div>

                  <div className="flex items-center gap-2">
                    <input
                      type="radio"
                      id="male"
                      name="gender"
                      value="male"

                      required
                      className="mr-2"
                    />
                    <label htmlFor="male" className="mr-4">
                      Male
                    </label>

                    <input
                      type="radio"
                      id="female"
                      name="gender"
                      value="female"
                      className="mr-2"
                    />
                    <label htmlFor="female">Female</label>
                  </div>
                </div>
              </div>

              <div className="mt-6">
                <label class="text-black text-base mt-6" for="resume">
                  Upload Resume
                  <span class="required text-red-500"> *</span>
                </label>
              </div>
              <input
                class=" py-2 w-full bg-white rounded borderform "
                type="file"
                id="resume"
                name="resume"
                accept=".pdf, .doc, .docx"
                required
              />

              <div className="flex justify-center  mt-6">
                <button
                  className=" px-8  mt-8  py-2 border-0 focus:outline-none text-white text-center rounded"
                  style={{ background: "#2d86a4" }}
                  type="submit"
                >
                  Submit
                </button>
              </div>
            </form>
          )}
        </div>
      </section>

      {/* <Footer2 /> */}
    </>
  );
}
